import { Form, Input, Select } from "antd";
import { useBrigadeList } from "@/modules/brigades/hooks/useBrigade";
import { useEquipmentTypes } from "@/modules/equipment-types/hooks/useEquipmentTypes";
import { useGpsDevices } from "@/modules/gps-devices/hooks/useGpsDevices";

const STATUS_OPTIONS: { value: string; label: string }[] = [
	{ value: "ACTIVE", label: "Faol" },
	{ value: "MAINTENANCE", label: "Ta'mirda" },
	{ value: "INACTIVE", label: "Faol emas" },
	{ value: "RETIRED", label: "Iste'foda" },
];

interface EquipmentFormProps {
	organizationId?: string;
}

export function EquipmentForm({ organizationId }: EquipmentFormProps) {
	const { data: typesData } = useEquipmentTypes({ limit: 10 });
	const equipmentTypes = typesData?.data?.items ?? [];

	const { data: gpsData } = useGpsDevices({
		organizationId: organizationId ?? "",
		page: 1,
		limit: 100,
	});
	const gpsDevices = gpsData?.data?.items ?? [];

	const { data: brigadesData } = useBrigadeList({
		organizationId: organizationId ?? "",
		page: 1,
		limit: 100,
	});
	const brigades = brigadesData?.data?.items ?? [];

	return (
		<>
			<Form.Item name="organizationId" hidden>
				<Input />
			</Form.Item>
			<div className="grid grid-cols-2 gap-4">
				<Form.Item
					name="name"
					label="Nomi"
					rules={[
						{ required: true, message: "Nomini kiriting" },
						{ max: 255, message: "Maksimum 255 ta belgi" },
					]}
				>
					<Input placeholder="Masalan: Truck 1" size="middle" />
				</Form.Item>
				<Form.Item
					name="typeId"
					label="Texnika turi"
					rules={[{ required: true, message: "Texnika turini tanlang" }]}
				>
					<Select
						placeholder="Texnika turini tanlang"
						showSearch
						filterOption={(input, option) =>
							(option?.label as string)?.toLowerCase().includes(input.toLowerCase())
						}
						options={equipmentTypes.map((t) => ({
							value: t.id,
							label: t.name,
						}))}
					/>
				</Form.Item>
				<Form.Item
					name="serialNumber"
					label="Seriya raqami"
					rules={[
						{ required: true, message: "Seriya raqamini kiriting" },
						{ max: 100, message: "Maksimum 100 ta belgi" },
					]}
				>
					<Input placeholder="Masalan: SN123456" size="middle" />
				</Form.Item>
				<Form.Item name="licensePlate" label="Davlat raqami">
					<Input placeholder="Masalan: ABC-123" size="middle" maxLength={20} />
				</Form.Item>
				<Form.Item name="status" label="Holati">
					<Select options={STATUS_OPTIONS} placeholder="Holatni tanlang" />
				</Form.Item>
				{organizationId && (
					<Form.Item name="gpsDeviceId" label="GPS qurilmasi">
						<Select
							placeholder="GPS qurilmasini tanlang (ixtiyoriy)"
							allowClear
							showSearch
							filterOption={(input, option) =>
								(option?.label as string)?.toLowerCase().includes(input.toLowerCase())
							}
							options={gpsDevices.map((d) => ({
								value: d.id,
								label: `${d.imei}${d.equipmentId ? " (band)" : ""}`,
							}))}
						/>
					</Form.Item>
				)}
				{organizationId && (
					<Form.Item name="brigadeId" label="Brigada">
						<Select
							placeholder="Brigadani tanlang (ixtiyoriy)"
							allowClear
							showSearch
							filterOption={(input, option) =>
								(option?.label as string)?.toLowerCase().includes(input.toLowerCase())
							}
							options={brigades.map((b) => ({
								value: b.id,
								label: b.name,
							}))}
						/>
					</Form.Item>
				)}
			</div>
		</>
	);
}
